var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import moment from 'moment';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { asText, SUCCESS_STATUS_CODE } from './service_helpers';
export var CREATE_COMMENT_STATUS = 'CREATE';
var byOldestFirst = function (left, right) {
    return new Date(left.createdTime).getTime() - new Date(right.createdTime).getTime();
};
export var fetchApplicationComments = function (applicationId, txAspireOId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, rows, error_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!applicationId && !txAspireOId) {
                    return [2, []];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4, api_service.get({
                        endPoint: api_urls.APPLICATION_COMMENT,
                        payLoad: applicationId
                            ? { ApplicationId: applicationId }
                            : { TxAspireOId: txAspireOId },
                        showLoader: false,
                    })];
            case 2:
                response = _b.sent();
                if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== SUCCESS_STATUS_CODE) {
                    return [2, []];
                }
                rows = Array.isArray(response.data.data) ? response.data.data : [];
                return [2, rows
                        .map(function (row) { return ({
                        commentedBy: asText(row.CommentedBy),
                        subject: asText(row.Subject),
                        text: asText(row.Text),
                        commentType: asText(row.CommentType),
                        createdTime: asText(row.CreatedTime),
                    }); })
                        .sort(byOldestFirst)];
            case 3:
                error_1 = _b.sent();
                return [2, []];
            case 4: return [2];
        }
    });
}); };
var buildCommentPayload = function (context, draft) {
    var payload = {
        Text: draft.text,
        IsDraft: context.applicationId ? 1 : 0,
    };
    var put = function (key, value) {
        if (value) {
            payload[key] = value;
        }
    };
    put('Status', context.status);
    put('ApplicationType', context.applicationType);
    put('SalesRepId', context.salesRepId);
    put('DealerAspireOId', context.dealerAspireOId);
    put('LocationAspireOId', context.locationAspireOId);
    put('LocationCode', context.locationCode);
    put('ProgramId', context.programId);
    put('ProgramAspireOId', context.programAspireOId);
    put('ApplicationId', context.applicationId);
    put('TxAspireOId', context.txAspireOId);
    put('Subject', draft.subject);
    put('CustomerName', draft.customerName);
    put('ContractAspireId', context.contractAspireId);
    return payload;
};
export var addApplicationComment = function (context, draft) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                return [4, api_service.post({
                        endPoint: api_urls.APPLICATION_COMMENT,
                        payLoad: buildCommentPayload(context, draft),
                        showLoader: true,
                    })];
            case 1:
                response = _c.sent();
                if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== SUCCESS_STATUS_CODE) {
                    return [2, { isSuccess: false, applicationId: '' }];
                }
                return [2, {
                        isSuccess: true,
                        applicationId: asText((_b = response.data.data) === null || _b === void 0 ? void 0 : _b.ApplicationId),
                    }];
            case 2:
                error_2 = _c.sent();
                return [2, { isSuccess: false, applicationId: '' }];
            case 3: return [2];
        }
    });
}); };
var capitaliseWords = function (text) {
    return text.replace(/\b\w/g, function (character) { return character.toUpperCase(); });
};
export var parseCommentSender = function (commentedBy) {
    if (!commentedBy) {
        return { name: '', role: '' };
    }
    var match = commentedBy.match(/^(.*?)\s*\(([^)]+)\)\s*$/);
    return match
        ? { name: capitaliseWords(match[1].trim()), role: match[2].trim() }
        : { name: capitaliseWords(commentedBy.trim()), role: '' };
};
export var formatCommentTime = function (createdTime) {
    var commentedAt = moment(createdTime);
    return commentedAt.isValid() ? commentedAt.format('MM/DD/YYYY | hh:mm A') : '';
};
